import { CustomRouteRecord } from '@/types/router/router';
import test from '@/views/modules/preview/pages/export-report-preview/ExportReportPreview.vue';

const reportRoute: Array<CustomRouteRecord> = [
  {
    path: '/report/main',
    name: 'report',
    component: () => import('@/views/modules/unauthorized/Unauthorized.vue'),
    breadcrumb: [
      {
        text: 'Report',
      },
    ],
  },
  {
    path: '/export/report-preview',
    name: 'report',
    component: () => import('@/views/modules/report-engine/page/ExportReportPreview.vue'),
    breadcrumb: [
      {
        text: 'Report',
      },
    ],
    meta: {
      layout: 'full',
    },
  },
];

export default reportRoute;
